<template>
  <el-dialog
    :title="formData && formData.id ? $t('components.CreateOrderDialog.939026-0') : $t('components.CreateOrderDialog.939026-1')"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="handleClose"
  >
    <el-form ref="orderForm" :model="form" :rules="rules" label-width="120px" label-position="right">
      <el-form-item :label="$t('components.CreateOrderDialog.939026-2')" prop="orderNo">
        <el-input v-model="form.orderNo" :placeholder="$t('components.CreateOrderDialog.939026-3')" :disabled="!!formData && !!formData.id" />
      </el-form-item>

      <el-form-item :label="$t('components.CreateOrderDialog.939026-4')" prop="uId">
        <el-select
          v-model="form.uId"
          filterable
          :loading="userLoading"
          :placeholder="$t('components.CreateOrderDialog.939026-5')"
          style="width: 100%"
          @change="handleUserChange"
        >
          <el-option v-for="item in userOptions" :key="item.id" :label="item.userName" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('components.CreateOrderDialog.939026-6')" prop="teamIds">
        <el-select
          v-model="form.teamIds"
          multiple
          filterable
          :loading="teamLoading"
          :placeholder="$t('components.CreateOrderDialog.939026-7')"
          style="width: 100%"
        >
          <el-option v-for="item in teamOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('components.CreateOrderDialog.939026-8')">
        <el-input v-model="form.notes" type="textarea" :rows="4" :placeholder="$t('components.CreateOrderDialog.939026-9')" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">{{ $t('components.CreateOrderDialog.939026-10') }}</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting" size="small">
        {{ $t('components.CreateOrderDialog.939026-11') }}{{ formData && formData.id ? $t('components.CreateOrderDialog.939026-12') : $t('components.CreateOrderDialog.939026-1') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "CreateOrderDialog",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      formData: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        dialogVisible: false,
        submitting: false,
        userLoading: false,
        teamLoading: false,
        form: {
          id: "",
          orderNo: "",
          uId: "",
          teamIds: [],
          notes: ""
        },
        rules: {
          orderNo: [{ required: true, message: this.$t('components.CreateOrderDialog.939026-3'), trigger: "blur" }],
          uId: [{ required: true, message: this.$t('components.CreateOrderDialog.939026-13'), trigger: "change" }]
        },
        userOptions: [],
        teamOptions: []
      };
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
        if (val) {
          this.loadAllUsers().then(() => {
            this.initForm();
          });
        }
      },
      dialogVisible(val) {
        this.$emit("update:visible", val);
      }
    },
    methods: {
      // 加载所有用户列表
      loadAllUsers() {
        this.userLoading = true;
        return this.$api
          .request(this.$url.UserMachine.listUser, this.$method.get)
          .then(res => {
            if (res.code === 0) {
              this.userOptions = Array.isArray(res.data) ? res.data : [];
            } else {
              this.$message.error(res.msg || this.$t('components.CreateOrderDialog.939026-14'));
            }
          })
          .catch(err => {
            this.$message.error(this.$t('components.CreateOrderDialog.939026-14'));
          })
          .finally(() => {
            this.userLoading = false;
          });
      },

      // 初始化表单
      initForm() {
        // 加载分组列表
        this.loadUserTeams();

        if (this.formData && this.formData.id) {
          // 编辑模式
          this.form = {
            id: this.formData.id,
            orderNo: this.formData.orderNo || "",
            uId: this.formData.uId || this.formData.insertUid || "",
            teamIds: this.formData.teamIds || [],
            notes: this.formData.notes || ""
          };
        } else {
          // 创建模式
          this.form = {
            id: "",
            orderNo: "",
            uId: "",
            teamIds: [],
            notes: ""
          };
        }
        this.$nextTick(() => {
          if (this.$refs.orderForm) {
            this.$refs.orderForm.clearValidate();
          }
        });
      },

      // 用户改变
      handleUserChange() {
        // 用户改变时不需要重新加载分组，因为分组列表已经全量加载了
      },

      // 加载分组列表
      loadUserTeams() {
        this.teamLoading = true;
        this.$api
          .request(this.$url.MachineGroup.list, this.$method.get)
          .then(res => {
            if (res.code === 0) {
              this.teamOptions = Array.isArray(res.data) ? res.data : [];
            } else {
              this.$message.error(res.msg || this.$t('components.CreateOrderDialog.939026-15'));
              this.teamOptions = [];
            }
          })
          .catch(err => {
            this.$message.error(this.$t('components.CreateOrderDialog.939026-15'));
            this.teamOptions = [];
          })
          .finally(() => {
            this.teamLoading = false;
          });
      },

      // 提交
      handleSubmit() {
        this.$refs.orderForm.validate(valid => {
          if (valid) {
            this.submitting = true;
            const url = this.form.id ? this.$url.ShippingOrder.update : this.$url.ShippingOrder.insert;
            const method = this.form.id ? this.$method.put : this.$method.post;
            const data = {
              orderNo: this.form.orderNo,
              uId: this.form.uId,
              teamIds: this.form.teamIds,
              notes: this.form.notes
            };
            if (this.form.id) {
              data.id = this.form.id;
            }

            this.$api
              .request(url, method, data)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.form.id ? this.$t('components.CreateOrderDialog.939026-16') : this.$t('components.CreateOrderDialog.939026-17'));
                  this.$emit("success");
                  this.handleClose();
                } else {
                  this.$message.error(res.msg || this.$t('components.CreateOrderDialog.939026-18'));
                }
              })
              .catch(err => {
                this.$message.error(this.$t('components.CreateOrderDialog.939026-19'));
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        });
      },

      // 关闭
      handleClose() {
        this.dialogVisible = false;
        this.form = {
          id: "",
          orderNo: "",
          uId: "",
          teamIds: [],
          notes: ""
        };
        this.userOptions = [];
        this.teamOptions = [];
        if (this.$refs.orderForm) {
          this.$refs.orderForm.clearValidate();
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .dialog-footer {
    text-align: right;
  }
</style>
